<template>
  <svg
    :width="`${size}px`"
    :height="`${size}px`"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>{{ title }}</title>
    <g id="Icon-/-Trash-Active" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <path
        id="Trash"
        d="M17.5878906,19.0673828 C17.5263672,20.1835938 16.7529297,20.9306641 15.6367188,20.9306641 L8.06933594,20.9306641 C6.94433594,20.9306641 6.1796875,20.1923828 6.12695312,19.0761719 L5.52929688,6.74511719 L4.53613281,6.74511719 C4.24609375,6.74511719 4,6.49902344 4,6.20898438 C4,5.91015625 4.24609375,5.6640625 4.53613281,5.6640625 L8.27148438,5.6640625 L8.27148438,4.38964844 C8.27148438,3.24707031 9.04492188,2.5 10.2753906,2.5 L13.4130859,2.5 C14.6435547,2.5 15.4257812,3.24707031 15.4257812,4.38964844 L15.4257812,5.6640625 L19.1699219,5.6640625 C19.4599609,5.6640625 19.6972656,5.91015625 19.6972656,6.20898438 C19.6972656,6.49902344 19.4599609,6.74511719 19.1699219,6.74511719 L18.1855469,6.74511719 L17.5878906,19.0673828 Z M9.4140625,4.45117188 L9.4140625,5.6640625 L14.2832031,5.6640625 L14.2832031,4.45117188 C14.2832031,3.93261719 13.9052734,3.5546875 13.3339844,3.5546875 L10.3544922,3.5546875 C9.79199219,3.5546875 9.4140625,3.93261719 9.4140625,4.45117188 Z M8.16601562,19.8583984 L15.53125,19.8583984 C16.0498047,19.8583984 16.4453125,19.4716797 16.4628906,18.953125 L17.0429688,6.74511719 L6.64550781,6.74511719 L7.24316406,18.953125 C7.26953125,19.4628906 7.66503906,19.8583984 8.16601562,19.8583984 Z M14.3271484,18.2939453 C14.0810547,18.2939453 13.8964844,18.0830078 13.9052734,17.8193359 L14.1689453,8.83691406 C14.1777344,8.57324219 14.3623047,8.37109375 14.5908203,8.37109375 C14.8457031,8.37109375 15.0214844,8.57324219 15.0214844,8.84570312 L14.7578125,17.828125 C14.7490234,18.1005859 14.5732422,18.2939453 14.3271484,18.2939453 Z M9.37890625,18.2939453 C9.1328125,18.2939453 8.95703125,18.1005859 8.94824219,17.828125 L8.68457031,8.84570312 C8.68457031,8.57324219 8.86035156,8.37109375 9.10644531,8.37109375 C9.33496094,8.37109375 9.52832031,8.57324219 9.53710938,8.83691406 L9.80078125,17.8193359 C9.80957031,18.0830078 9.625,18.2939453 9.37890625,18.2939453 Z M12.296875,17.8193359 C12.296875,18.0830078 12.0947266,18.2939453 11.8574219,18.2939453 C11.6201172,18.2939453 11.4179688,18.0830078 11.4179688,17.8193359 L11.4179688,8.83691406 C11.4179688,8.57324219 11.6201172,8.37109375 11.8574219,8.37109375 C12.0947266,8.37109375 12.296875,8.57324219 12.296875,8.83691406 L12.296875,17.8193359 Z"
        fill="#2F477C"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: false,
      default: '24',
    },
    title: {
      type: String,
      default: 'Delete',
    },
  },
};
</script>
